// src/pages/QRPage.js
import React from "react";
import QRDisplay from "../components/QRDisplay";

const QRPage = () => {
  return (
    <div>
      <QRDisplay />
    </div>
  );
};

export default QRPage;
